import { render } from "./RFIDCardsMetrics.vue?vue&type=template&id=08dd79d4"
import script from "./RFIDCardsMetrics.vue?vue&type=script&lang=js"
export * from "./RFIDCardsMetrics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__